import { getAuth } from 'firebase/auth';
import React from 'react';

export const useAuthToken = () => {
  const [authToken, setAuthToken] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    getAuth()
      .currentUser?.getIdToken()
      .then((token) => {
        setAuthToken(token);
      })
      .catch((e) => {
        console.error(e);
        setAuthToken(undefined);
      });
  }, []);

  return authToken;
};
